
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FooterCellListResource } from "app/models/FooterCellListResource";
import { FooterConfigService } from "app/homepage-configuration/footer-config/footer-config.service";
import { NotificationsService } from "angular2-notifications";
import { TranslateService } from '@ngx-translate/core';
import { DragulaService } from "ng2-dragula";

@Component({
  selector: 'vbn-footer-column-shift',
  templateUrl: './footer-column-shift.component.html',
  providers: [FooterConfigService],
  styleUrls: ['./footer-column-shift.component.scss']
})
export class FooterColumnShiftComponent implements OnInit {
  dragulaDrop: any;
  footerCellListResourceActive: FooterCellListResource;
  errorMessage: any;
  showShiftBtn:boolean = false;
  showConfirmation;
  user = localStorage.getItem("_user");

  constructor(private footerConfigService: FooterConfigService,
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private dragulaService: DragulaService
  ) {
    this.dragulaDrop = dragulaService.drop.subscribe((value) => {
      this.endShift(value)

    });
    this.footerCellListResourceActive = new FooterCellListResource();
  }

  ngOnInit() {
    this.getAllFooterCellActive();
  }
   ngOnDestroy(): void {
    this.dragulaDrop.unsubscribe();
  }
  getAllFooterCellActive() {
    this.footerConfigService.getCellActive('/admin/footer/cell/getActive?email=' + this.user)
      .subscribe(
      body => {
        this.footerCellListResourceActive = body;
        if(this.footerCellListResourceActive != null){
          if(this.footerCellListResourceActive.footerCellListResource != null){
            let count = this.footerCellListResourceActive.footerCellListResource.length;
            if(count>=2){
              this.showShiftBtn = true;
            }
          }
        }
      },
      error => this.errorMessage = <any>error)
  }

  endShift(htmlRef) {
    let rid = htmlRef[1].getAttribute("homepage-rid")
    let oldPos = parseInt(htmlRef[1].getAttribute("index"))
    let newPos = undefined
    let homepageList = htmlRef[2].children;

    for (let i = 0; i < homepageList.length; i++) {
      let k = homepageList[i].getAttribute("homepage-rid")
      if (rid == k) {
        newPos = i
        break;
      }
    }

    console.log("----------------", newPos, oldPos)
    this.footerConfigService.shiftElements(`/admin/footer/cell/shift?oldPosition=` + oldPos + "&newPosition=" + newPos + "&email=" + this.user, null )
      .subscribe(
      response => {
        this.footerCellListResourceActive = response;
        observableForkJoin(
          this.translate.get('Success'),
          this.translate.get('Elements shifted with success!')
        ).subscribe((res) => {
          this._notificationService.create(res[0], res[1], 'success')
        })
        this.getAllFooterCellActive();
       // this.getFooterCellListComponent();
        // this._notificationService.create("Success", 'Elements shifted with success!', 'success')
      },
      error => this.errorMessage = <any>error);
  }

}
